import './../globals.js'
import store from '@/components/store.js'
import C from './../constants.js'
import router from './../router'
import Vue from 'vue'

export default function CstSurveyBaseDeck (parent, data) {
  var cards = []
  var questions = {}
  var questionsRemaining = []

  var modules = {}

  var allQuestions = []
  var shownQuestions = {}

  // var self = this

  // var was_inited = false

  var uuidv4 = function () {
    var uuid = ''
    var i
    var random
    for (i = 0; i < 32; i++) {
      random = Math.random() * 16 | 0
      if (i === 8 || i === 12 || i === 16 || i === 20) {
        uuid += '-'
      }
      uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16)
    }
    return uuid
  }

  var question_answered = function (answer, progress = true) {
    questions[answer.questionId * 1].answer = answer
    if (parent.current_card().isValid()) {
      parent.answerQuestion(answer)
    }
    if (progress) {
      window.eventHub.$emit('card-next')
    }
  }

  // var deck_finished = function () {
  //   console.log('DECK FINISHED')
  // }

  var findNextQuestion = function () {
    for (var index in allQuestions) {
      let currentQuestion = allQuestions[index]
      let usable = hasAllDependencies(currentQuestion)
      if (usable && !isQuestiondAlreadyOut(currentQuestion)) {
        return index
      }
    }
    return -1
  }

  var isQuestiondAlreadyOut = function (question) {
    return (question.id in shownQuestions)
  }

  var getRemainingCardCount = function () {
    let allRemainingQuestions = allQuestions.filter(function (q) { return hasAllDependencies(q) })
    let allRemainingDefaultCards = defaultStack.filter(function (c) { return !!(c.countsTowardsProgress) })
    return allRemainingQuestions.length - (Object.keys(shownQuestions).length + allRemainingDefaultCards.length)
  }

  var findFirstUnansweredQuestion = function () {
    for (var index in allQuestions) {
      let currentQuestion = allQuestions[index]
      let answered = isAnswered(currentQuestion)
      let dependenciesFulfilled = hasAllDependencies(currentQuestion)
      if (!answered && dependenciesFulfilled && !(shownQuestions[currentQuestion.id])) {
        return index * 1
      }
    }
    return -1
  }

  var getLastAnsweredQuestion = function () {
    let lastAnsweredIndex = 0
    for (var index in allQuestions) {
      let currentQuestion = allQuestions[index]
      let answered = isAnswered(currentQuestion)
      if (answered) {
        lastAnsweredIndex = index
      }
    }
    return lastAnsweredIndex * 1
  }

  var hasTypeDependencies = function (dependencyType, questionaire) {
    for (var index in allQuestions) {
      let question = allQuestions[index]
      for (var dindex in question.dependencies) {
        let dependency = question.dependencies[dindex]
        if (dependency.type === dependencyType && isDependencyFulfillable(dependency, questionaire)) {
          return true
        }
      }
    }
    return false
  }

  var isDependencyFulfillable = function (dependency, questionaire) {
    if (dependency.type === 'module') {
      let isFulfillable = questionaire.modules.filter(function (m) { return m.id === dependency.id }).length > 0
      return isFulfillable
    }
    return true
  }

  var hasNextCard = function () {
    return findNextQuestion() !== -1 || defaultStack.length > 0
  }

  var initDefaultStack = function (data) {
    let questionaire = data.questionaire
    var stack = [
      {
        type: 'card-finished', id: uuidv4(), countsTowardsProgress: false
      }
    ]
    if (data.options.includes('holidaycheck')) {
      stack.unshift(
        {
          type: 'card-hc-selector'
        },
        {
          type: 'card-holiday-check'
        }
      )
    }
    if (questionaire.has_additional_questions || hasTypeDependencies('module', questionaire)) {
      stack.unshift(
        {
          type: 'card-thanks', id: uuidv4(), countsTowardsProgress: false
        },
        {
          type: 'card-question-selector',
          id: uuidv4(),
          skippable: function () { return true },
          content: {
            hasExternalQuestions: questionaire.has_additional_questions
          }
        }
      )
    }
    return stack
  }

  var defaultStack = [
  ]

  var removeCard = function (card) {
    if (card.type === 'card-question') {
      delete shownQuestions[card.content.id]
    } else {
      defaultStack.unshift(card)
    }
  }

  var insertHistoryCards = function (cardId) {
    var cardIndex = router.currentRoute.params.cardId
    var cardsInserted = 0
    var questionsToInsert = []
    for (var i in questionsRemaining) {
      var currentQuestion = questionsRemaining[i]
      if (hasAllDependencies(currentQuestion)) {
        questionsToInsert.push(currentQuestion)
        cardsInserted++
      }
      if (cardsInserted >= cardIndex) {
        break
      }
    }
    for (i in questionsToInsert) {
      var question = questionsToInsert[i]
      addQuestionToGame(question)
    }
  }

  var addCardtoGame = function (card) {
    store.commit('addCard', card)
    cards.push(card)
  }

  var addQuestionToGame = function (question) {
    var card = generateCardFromQuestion(question.id)
    addCardtoGame(card)
    shownQuestions[question.id] = 1
    questionsRemaining = questionsRemaining.filter(function (question) { return !shownQuestions[question.id] })
  }

  var prepareDeck = function () {
    if (router.currentRoute.params.cardId) {
      insertHistoryCards(router.currentRoute.params.cardId)
      store.commit('setCardIndex', router.currentRoute.params.cardId)
    } else {
      insertAnsweredCards()
      //      store.commit('setCardIndex', findFirstUnansweredQuestion())
    }
  }

  var getNextCard = function () {
    //    return {
    //      type: 'card-holiday-check', id: uuidv4(), countsTowardsProgress: false
    //    }
    var nextQuestionIndex = -1
    // if (!was_inited) {
    //   nextQuestionIndex = findFirstUnansweredQuestion()
    //   was_inited = true
    // }
    // wenns keine unbeantworte frage gibt aber schon antworten
    // -> die erste karte anspringen
    if (nextQuestionIndex === -1) {
      nextQuestionIndex = findNextQuestion()
    }
    let card
    if (nextQuestionIndex !== -1) {
      let nextQuestion = allQuestions[nextQuestionIndex]
      card = generateCardFromQuestion(nextQuestion.id)
      shownQuestions[nextQuestion.id] = 1
    } else {
      card = defaultStack.shift()
    }
    this.cards.push(card)
    // currentCard = card
    return card
  }

  // var generateAllCards = function () {
  //   var questionStack = []
  //   for (var q in allQuestions) {
  //     var question = allQuestions[q]
  //     if (hasAllDependencies(currentQuestion)) {
  //       questionStack.push(question)
  //     }
  //   }
  // }

  // theoretisch koennten die aber doppelt sein, müsste man filtern oder?
  // current card und current deck vvlt?
  // var getNextCardNew = function (currentCard) {
  //   var stack = generateAllCards()
  //   var nextCard = 0
  //   for (var c in stack) {
  //     var card = stack[c]
  //     if (card.content.id === currentCard.content.id) {
  //       nextCard = c + 1
  //       break
  //     }
  //   }
  //   return generateCardFromQuestion(stack[nextCard])
  // }

  var mergeDeck = function (questionaire) {
    var questionsNew = generateQuestions(questionaire.questions)
    questionsRemaining = questionsRemaining.concat(questionsNew)
    allQuestions = allQuestions.concat(questionsNew)

    modules.splice(0, modules.length)
    for (var m in questionaire.modules) {
      modules.push(questionaire.modules[m])
    }
  }

  var insertAnsweredCards = function () {
    let filledQuestions = getAnsweredQuestions()
    for (var i in filledQuestions) {
      addQuestionToGame(filledQuestions[i])
    }
  }

  var getAnsweredQuestions = function () {
    let firstUnansweredCardIndex = findFirstUnansweredQuestion()
    let lastAnsweredIndex = getLastAnsweredQuestion()
    let indexToStop = firstUnansweredCardIndex
    if (lastAnsweredIndex > firstUnansweredCardIndex && questionsRemaining.length > lastAnsweredIndex) {
      indexToStop = lastAnsweredIndex * 1 + 1
    }
    let filledCards = []
    for (var i = 0; i < indexToStop; i++) {
      let question = questionsRemaining[i]
      if (hasAllDependencies(question)) {
        filledCards.push(question)
      }
    }
    return filledCards
  }

  var hasAllDependencies = function (question) {
    let unfulfilledDependencies = []
    for (var d in question.dependencies) {
      let dependency = question.dependencies[d]
      let isFulfilled = isDependencyFulfilled(dependency)
      if (!isFulfilled) {
        unfulfilledDependencies.push(dependency)
      }
    }
    return unfulfilledDependencies.length === 0
  }

  var isAnswered = function (question) {
    // answerText: '', answerScore: -1, answerValue: '', answerId: -1
    return question.answer.answerValue !== '' || question.answer.answerScore !== -1 || question.answer.answerText !== ''
  }

  var isDependencyFulfilled = function (dependency) {
    if (dependency.type === 'module') {
      return store.state.selectedModules.indexOf(parseInt(dependency['id'])) !== -1
    } else if (dependency.type === 'regular') {
      return store.state.visit.customer_visit_regular * 1 === dependency['value'] * 1
    } else if (dependency.type === 'category') {
      return store.state.visit.customer_visit_category * 1 === dependency['value'] * 1
    } else if (dependency.type === 'question' && dependency.id in questions) {
      var a = questions[dependency.id].answer.answerValue * 1
      var val = dependency['value'] * 1
      switch (dependency['operator']) {
        case '==': // 1: '==',
          return a === val

        case '!=': // 2: '!=',
          return a !== val

        case '>': // 3: '>',
          return a > val

        case '>=': // 4: '>=',
          return a >= val

        case '<': // 5: '<',
          return a < val

        case '<=': // 6: '<='
          return a <= val

        default:
          return false
      }
    }
    return true
  }

  var generateCardFromQuestion = function (questionId) {
    let card_id = uuidv4()
    let question = questions[questionId]
    var validate = function () { return true }
    var isValid = function () { return true }
    var cardType = 'card-question'
    if (question.options.indexOf('is_public_question') !== -1) {
      cardType = 'card-public-question'
      isValid = function () {
        if (question.answer.answerText !== '' && !question.privacy) {
          return false
        }
        return true
      }
      validate = function () {
        if (!isValid()) {
          content['errors'].push('error_privacy')
          return false
        }
        return true
      }
    }

    var skippable = function () {
      return question.optional * 1 || question.answer.answerValue !== '' || question.answer.answerText !== ''
    }

    let content = question
    content.skippable = skippable
    Vue.set(content, 'errors', [ ])
    return {
      type: cardType,
      id: card_id,
      content: content,
      skippable: skippable,
      validate: validate,
      isValid: isValid
    }
  }

  var generateQuestions = function (questions_raw) {
    var answers = store.state.answers
    var questions_out = []
    for (var key in questions_raw) {
      var question = questions_raw[key]
      let found_answer = answers && question.id in answers ? answers[question.id] : false
      let answer
      if (found_answer) {
        answer = { answerText: found_answer.text, answerScore: found_answer.score, answerValue: found_answer.value, answerId: found_answer.value }
      } else {
        answer = { answerText: '', answerScore: -1, answerValue: '', answerId: -1 }
      }
      question.answer = answer

      // muessten die insgesamt neu gesorted werden?
      // questions filtern die schon da sind
      if (!(question.id in questions)) {
        questions[question.id] = question
        questions_out.push(question)
      } else {
        questions[question.id] = question
      }
    }
    return questions_out
  }

  var changeLocale = function (locale) {
    var actions = [parent.loadSurvey(store.state.surveyId, store.state.surveyKey, store.state.locale)]
    if (store.state.loadedExtendedQuestionaire) {
      actions.push(parent.loadExtendedSurvey({ modules: store.state.selectedModules }))
    }
    actions.push(parent.updateSurveyLanguage(locale))
    return Promise.all(actions)
  }

  var init = function () {
    if (data.survey.survey_status * 1 === C.SURVEY_STATUS_FINISHED) {
      defaultStack = [{
        type: 'card-survey-done'
      }]
      store.state.is_survey_finished = true
    } else {
      modules = data.questionaire.modules
      var questionsNew = generateQuestions(data.questionaire.questions)
      questionsRemaining = questionsRemaining.concat(questionsNew)
      allQuestions = allQuestions.concat(questionsNew)
      window.eventHub.$on('answer-question', question_answered)
      defaultStack = initDefaultStack(data)
    }
    prepareDeck()
  }
  init()
  return {
    changeLocale: changeLocale,
    type: 'survey',
    current_card_index: 0,
    cards: cards,
    modules: modules,
    questions: questions,
    // questions: questions,
    getNextCard: getNextCard,
    getRemainingCardCount: getRemainingCardCount,
    hasNextCard: hasNextCard,
    removeCard: removeCard,
    mergeDeck: mergeDeck
  }
}



// WEBPACK FOOTER //
// ./src/components/CstSurveyBaseDeck.js